import { connect } from 'react-redux';
import { RootState } from '../../../core/redux/store';
import { selectWindowById } from '../../redux/windowsSlice';
import {
  ApplicationType,
  AppWindow as IAppWindow,
  WindowGeometry,
} from '../../types';
import useAppWindow, {
  AppWindowMapProps,
  AppWindowProps,
} from '../../hooks/useAppWindow';
import ControlBar from '../organisms/ControlBar';
import Resizers from '../../../app/components/resizers/Resizers';
import { CSSProperties, useMemo } from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';
import useAppWindowValidation from '../../hooks/useAppWindowValidation';
import SheetStatusBar from '../organisms/SheetStatusBar';
import SheetApp from '../../../sheet';

const AppWindow: React.FC<AppWindowProps & AppWindowMapProps> = (props) => {
  const isLoading = useAppWindowValidation(props.id, props.metaData);
  const { windowGeometry, onResize, controlBarProps, setActive } =
    useAppWindow(props);
  const borderColor = useColorModeValue('gray.100', 'gray.800');
  // const backgroundColor = useColorModeValue('#fff', '#27374D');

  // console.log('props.', props.id, props.sheetId);

  const resizerView = (
    <Resizers
      onResize={onResize}
      geometry={windowGeometry}
      disabled={props.isMaximized}
    />
  );

  const controlBarView = (
    <ControlBar
      windowId={props.id}
      {...controlBarProps}
      metaData={props.metaData}
    />
  );

  const sheetsStatusBarView = props.metaData &&
    props.metaData.appType === ApplicationType.Sheet && (
      <SheetStatusBar
        groupId={props.metaData.groupId}
        windowId={props.id}
        sheetId={props.metaData.sheetId}
      />
    );

  const renderApp = () => {
    if (props.metaData?.appType === ApplicationType.Sheet) {
      // return null;
      return (
        <SheetApp
          sheetId={props.metaData.sheetId}
          width={windowGeometry.width}
          height={windowGeometry.height}
          x={windowGeometry.x}
          y={windowGeometry.y}
          windowId={props.id}
        />
      );
    }
  };

  return useMemo(
    () => (
      <Box
        style={container(windowGeometry, props.zIndex, props.isActive)}
        onMouseDown={setActive} // TODO: Add a mode check in function if is in selection mode than set temporarySheets active
        boxShadow={props.isActive ? '2xl' : 'md'}
        position="absolute"
        bg="InfoBackground"
        borderRadius={10}
        border="1px"
        borderColor={borderColor}
        overflow="hidden"
        // background={backgroundColor}
      >
        {/* {windowValidation} */}
        {resizerView}
        {controlBarView}
        {renderApp()}
        {/* <div>{props.metaData?.appType}</div> */}
        {/* {sheetsStatusBarView} */}
        {/* <div>
          {props.metaData?.appType === ApplicationType.Sheet
            ? props.metaData.sheetId
            : ''}
        </div> */}
      </Box>
    ),
    [
      windowGeometry.x,
      windowGeometry.y,
      windowGeometry.width,
      windowGeometry.height,
      onResize,
      controlBarProps,
      props.metaData,
      // props.sheetId,
      // props.appType,
      // props.groupId,
    ]
  );
};

const container = (
  geometry: WindowGeometry,
  zIndex: number,
  isActive?: boolean
) =>
  ({
    top: `${geometry.y}px`,
    left: `${geometry.x}px`,
    width: `${geometry.width}px`,
    height: `${geometry.height}px`,
    zIndex: zIndex,
  } as CSSProperties);

const mapStateToProps = (state: RootState, props: AppWindowProps) => {
  const window: IAppWindow | null = selectWindowById(props.id)(state);

  return {
    id: window?.id ?? '',
    x: window?.x ?? 0,
    y: window?.y ?? 0,
    height: window?.height ?? 0,
    width: window?.width ?? 0,
    metaData: window?.metaData,
    // sheetId: window?.sheetId ?? '',
    // groupId: window?.groupId ?? '',
    // appType: window?.appType ?? ApplicationType.Sheet,
    isMaximized: !!window?.isMaximized,
    isMinimized: !!window?.isMinimized,
  };
};

export default connect(mapStateToProps)(AppWindow);
